import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, computedFrom, Disposable } from 'aurelia-framework';
import { IAccountTagAM } from '../account-tag-api';

@autoinject
export class AccountTagFilter {
	@bindable accountTags: IAccountTagAM;
	@bindable onSelect: (params: any) => void;

	selectListOpen = false;
	onBodyClick: (Event) => void;
	dropdownOpenedSubscriber: Disposable;
	selectedAccountTag: IAccountTagAM;

	constructor(private eventAggregator: EventAggregator) {
		this.onBodyClick = () => { this.close(); };
	}

	@computedFrom('selectedAccountTag')
	get selectedAccountTagId() {
		return this.selectedAccountTag != null
			? this.selectedAccountTag.id
			: null;
	}

	attached() {
		document.addEventListener('click', this.onBodyClick);

		this.dropdownOpenedSubscriber =
			this.eventAggregator.subscribe('dropdownOpened', (viewModel: any) => {
				if (viewModel !== this) {
					this.close();
				}
			});
	}

	detached() {
		document.removeEventListener('click', this.onBodyClick);
		this.dropdownOpenedSubscriber.dispose();
	}

	onToggleClick(event: Event) {
		event.stopPropagation();
		this.toggleSelectList();

		if (this.selectListOpen) {
			this.eventAggregator.publish('dropdownOpened', this);
		}
	}

	toggleSelectList() {
		this.selectListOpen = !this.selectListOpen;
	}

	select(accountTag: IAccountTagAM) {
		this.selectedAccountTag = accountTag;
		this.onSelect({ tag: accountTag });
	}

	close() {
		this.selectListOpen = false;
	}
}
